/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2IconVoiceMailDisconnect/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2IconVoiceMailDisconnect({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2IconVoiceMailDisconnect",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2IconVoiceMailDisconnect.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-271bry': alignSelf,'--mt-2-271bry': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-271bry': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-271bry': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-271bry': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-271bry': opacity,'--w-10-271bry': typeof width === 'number' ? `${width}px` : width,'--h-11-271bry': typeof height === 'number' ? `${height}px` : height,'--f-12-271bry': fill,'--a-7-271bry': isAnimated ? animation : "none",'--sd-8-271bry': isAnimated ? strokeDashoffset : 0,'--sd-9-271bry': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2IconVoiceMailDisconnect.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_382_98393)"
 className="views-block"
>
<path
  data-testid="Tysiav2IconVoiceMailDisconnect.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M5.164.096A2.955 2.955 0 002.21 3.05v2.455a2.955 2.955 0 105.91 0V3.051A2.955 2.955 0 005.165.096zM.745 5.863c.345 0 .625.28.625.625A2.812 2.812 0 004.182 9.3h1.964a.625.625 0 110 1.25H5.79v1.34a.625.625 0 01-1.25 0v-1.34h-.357A4.062 4.062 0 01.12 6.488c0-.345.28-.625.625-.625zM13.78 8.48a.75.75 0 010 1.061l-1.59 1.59 1.59 1.59a.75.75 0 01-1.06 1.06l-1.59-1.59-1.59 1.59a.75.75 0 11-1.06-1.06l1.59-1.59-1.59-1.59a.75.75 0 011.06-1.06l1.59 1.59 1.59-1.59a.75.75 0 011.06 0z"
 style={{'--f-12-271bry': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}